import React from 'react';
import {LoadingDot} from './LoadingDot';

interface Props {}

export const Loading: React.FC<React.PropsWithChildren<Props>> = () => {
    return (
        <div
            className="m-auto flex w-24 flex-row justify-center gap-2 overflow-hidden py-4"
            style={{backgroundColor: 'transparent'}}
        >
            <LoadingDot
                style={{animationDelay: '100ms'}}
                src={
                    'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/d15c753b-4219-48fa-8530-3a79357f0659.svg?alt=media&token=9d42148e-43d8-4ecb-ae4d-bbb544ab4879'
                }
            />
            <LoadingDot
                style={{animationDelay: '200ms'}}
                src={
                    'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/c84ffc45-341a-4051-bc80-563022626d95.svg?alt=media&token=690a080c-bc29-48aa-9cb1-29df2cf1cf2a'
                }
            />
            <LoadingDot
                src={
                    'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/78126f4c-056f-4978-8154-46539af1ae41.svg?alt=media&token=6594c16e-7362-47ab-bac5-f9256683dab3'
                }
            />
        </div>
    );
};
